import React from "react";
import PropTypes from "prop-types";

import cn from "./style.module.scss";

export function Option(props) {
  let cls = [cn.optionListItem, props.className];
  if (props.selected) {
    cls = [cn.optionListItem, cn.selected, props.className];
  }
  const className = cls.join(" ");
  return (
    <li
      role="option"
      aria-selected={props.children}
      tabIndex={0}
      onClick={props.onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          props.onClick();
        }
      }}
      className={className}
    >
      {props.children}
    </li>
  );
}

Option.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * onClick
   */
  onClick: PropTypes.func,
  /**
   * bool to set option is selected
   */
  selected: PropTypes.bool,
};

Option.defaultProps = {
  className: "",
  selected: false,
};
